import React, { Component } from "react";

export default function wrapperComponent(CustomComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedOption: "",
        disabledData: this.props.disabledOptionsId || []
      };
    }

    componentWillReceiveProps(nextProps){
      this.setState({
        disabledData: nextProps.disabledOptionsId
      })
    }

    // handleSelect = e => {
    //   console.log("HandleSelect e: ", e);
    //   this.setState(
    //     {
    //       selectedOption: '4'
    //     },
    //     () => {
    //       let copyDisabledData = this.state.disabledData;
    //       copyDisabledData.length > 0
    //         ? (copyDisabledData[
    //             copyDisabledData.length - 1
    //           ] = this.state.selectedOption)
    //         : (copyDisabledData[0] = this.state.selectedOption);
    //       this.setState({
    //         disabledData: copyDisabledData
    //       });
    //     }
    //   );
    // };

    handleEdit = CustomComponentName => e => {
      switch (CustomComponentName) {
        case 'InputField':
          this.props.onChange(e);
          break;
        case 'DropDownSelect':
          this.props.handleEdit(e);
          break;
        default:
          console.log('Unhandled operation');
      }
    };

    handleBlur = e => {
      console.log("To be blurreddd");
    };

    render() {
      return (
        <CustomComponent
          onSelect={this.handleSelect}
          onEdit={this.handleEdit(CustomComponent.getClassName())}
          onBlur={this.handleBlur}
          selectedValue={this.state.selectedOption}
          disabledOptionsId={this.state.disabledData}
          {...this.props}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/common/WrapperComponent/WrapperComponent.js